import React from 'react';
import { FormControl, Select, MenuItem, InputLabel } from '@mui/material';

const dateFilterOptions = [
    { value: '7days', label: 'Last 7 Days' },
    { value: '1month', label: 'Last Month' },
    { value: '3months', label: 'Last 3 Months' },
    { value: '6months', label: 'Last 6 Months' },
    { value: '1year', label: 'Last Year' },
    { value: 'all', label: 'All' },
];

function DateRangeFilter({ value, onChange, sx, fullWidth }) {
    return (
        <FormControl sx={{ minWidth: 200, ...sx }} fullWidth={fullWidth}>
            <InputLabel>Date Range</InputLabel>
            <Select
                value={value}
                onChange={onChange}
                label="Date Range"
                fullWidth={fullWidth}
            >
                {dateFilterOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export { DateRangeFilter, dateFilterOptions };

